import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import API from '../../utils/API';
import LoadingWizard from '../../components/spinner/wizard';
import BookingCalendars from '../../sections/booking/calendars';
import BookingMeetings from '../../sections/booking/meetings';
import BookingRegistrants from '../../sections/booking/registrants';
import BookingFormBuilder from '../../sections/booking/formBuilder';
import BookingEmailTemplates from '../../sections/booking/emailTemplates';
import BookingDashboard from '../../sections/booking/dashboard';
import BookingPublish from '../../sections/booking/publish';
import { filter } from 'lodash';
class BookingPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			bookingPage: {},
			loading: true,
			section: 0,
			sectionIndex: 0,
			sectionName: 'Booking Details',
			sideMenuItems: this.props.sideMenuItems,
			eventMap: {},
			venues: [],
			eventVenue: null
		};
	}

	async componentDidMount() {
		const bookingPageId = this.props.match.params.bookingPage;
		let { sideMenuItems } = this.state;
		const { orgId, match: { params } } = this.props;
		const section = params.section;

		if (section) {
			let sectionIndex = 0;
			let sectionName = '';
			sideMenuItems = sideMenuItems.map((emi, index) => {
				emi.target = `/${orgId}/booking/${bookingPageId}/${emi.section}/`;
				if (emi.section === section) {
					sectionIndex = index;
					sectionName = emi.name;
				}
				return emi;
			});
			this.setState({
				section: section,
				sectionIndex: sectionIndex,
				sectionName: sectionName,
				sideMenuItems: sideMenuItems
			});
		}
		await API().get(`Organizations/${this.props.orgId}/eventNames`)
			.then((res) => {
				if (res.data) {
					const eventMap = {};
					res.data.events.forEach(event => {
						eventMap[event._id] = event;
					});
					this.setState({
						eventMap: eventMap,
					});
				}
			})
			.catch((e) => {
				console.log(e);
			});

		API()
			.get(`Organizations/${orgId}/bookingPages/${bookingPageId}`)
			.then((res) => {
				if (res.data) {
					const mappedBookingPage = res.data;

					// Map calendars with additional computed fields
					mappedBookingPage.calendars = mappedBookingPage.calendars.map((calendar) => {

						let filteredBookedSpots = calendar.bookedSpots || [];
						filteredBookedSpots = filter(filteredBookedSpots, (spot) => spot.status !== 'canceled');

						return {
							...calendar,

							bookingsCount: filteredBookedSpots ? filteredBookedSpots.length : 0,
							link: `/${orgId}/booking/${bookingPageId}/calendars/${calendar._id}`
						};
					});

					// Add link property to requests for navigation
					mappedBookingPage.requests = mappedBookingPage.requests.map((request) => {
						return {
							...request,
							link: `/${orgId}/booking/${bookingPageId}/requests/${request._id}`
						};
					});
					if (mappedBookingPage.isPartofEvent && mappedBookingPage?.eventId?.venue) {
						const { eventMap } = this.state;
						const event = eventMap[mappedBookingPage.eventId._id] || null;
						console.log(event);
						if (event && event.venue) {
							this.getVenues(event.venue);
						}
					}

					this.setState({ bookingPage: mappedBookingPage, loading: false });
				}
			})
			.catch((e) => {
				console.log(e);
				this.setState({ loading: false });
			});

	}

	getVenues = (venueId) => {
		const { orgId } = this.props;
		const { eventMap, bookingPage } = this.state;
		// Fetch venues for the organization
		if (!orgId) return;
		API().get(`Organizations/${orgId}/venues`).then((res) => {
			if (res.data) {
				const venues = res.data;
				const eventVenue = venues.find(v => v._id == venueId) || null;
				this.setState({ eventVenue: eventVenue });
			}
		});
	};

	componentDidUpdate(prevProps) {
		if (this.props.match.params.bookingPage !== prevProps.match.params.bookingPage) {
			this.componentDidMount();
		}
	}

	saveBookingPageDetails = async (editedDetails, callback) => {
		console.log('Saving booking page details:', editedDetails);
		const { orgId } = this.props;
		const payload = {
			request: 'updateBookingDetails',
			details: editedDetails
		};
		API().patch(`Organizations/${orgId}/bookingPages/${this.state.bookingPage._id}`, payload).then((res) => {
			if (res.data) {
				this.setState({ bookingPage: editedDetails });
				callback && callback();
			}
		});
	};

	addCalendar = async (calendar, callback) => {
		// Keep the API call for future backend integration
		const { orgId } = this.props;
		const payload = {
			request: 'addCalendar',
			calendar: calendar
		};
		API().patch(`Organizations/${orgId}/bookingPages/${this.state.bookingPage._id}`, payload).then((res) => {
			if (res.data) {
				const addedCalendar = res.data.calendar;
				const updatedBookingPage = {
					...this.state.bookingPage,
					calendars: [...this.state.bookingPage.calendars, {
						...addedCalendar,
						bookingsCount: addedCalendar.bookedSpots ? addedCalendar.bookedSpots.length : 0,
						link: `/${orgId}/booking/${this.state.bookingPage._id}/calendars/${addedCalendar._id}`
					}]
				};
				this.setState({ bookingPage: updatedBookingPage });
				callback && callback(updatedBookingPage.calendars[updatedBookingPage.calendars.length - 1]);
			}
		});
	};

	saveCalendar = async (calendar, callback) => {

		const { orgId } = this.props;
		const payload = {
			request: 'updateCalendar',
			calendar: calendar
		};
		API().patch(`Organizations/${orgId}/bookingPages/${this.state.bookingPage._id}`, payload).then((res) => {
			if (res.data) {
				const updatedBookingPage = {
					...this.state.bookingPage,
					calendars: this.state.bookingPage.calendars.map((c) => {
						let filteredBookedSpots = c.bookedSpots || [];
						filteredBookedSpots = filter(filteredBookedSpots, (spot) => spot.status !== 'canceled');

						if (c._id === calendar._id) {
							return {
								...c,
								...calendar,
								bookingsCount: filteredBookedSpots ? filteredBookedSpots.length : 0,
								link: `/${orgId}/booking/${this.state.bookingPage._id}/calendars/${c._id}`
							};
						}
						return c;
					})
				};
				this.setState({ bookingPage: updatedBookingPage });
				callback && callback();
			}
		});
	};

	deleteCalendars = async (calendarIds, callback) => {
		const { orgId } = this.props;
		const calendarIdsArray = Object.keys(calendarIds);

		try {
			for (const calendarId of calendarIdsArray) {
				await API().patch(`Organizations/${orgId}/bookingPages/${this.state.bookingPage._id}`, {
					request: 'removeCalendar',
					calendar: { _id: calendarId }
				});
			}

			const filteredCalendars = this.state.bookingPage.calendars.filter((c) => !calendarIds[c._id]);

			const updatedBookingPage = {
				...this.state.bookingPage,
				calendars: filteredCalendars
			};

			this.setState({ bookingPage: updatedBookingPage });
			callback && callback(updatedBookingPage);
		} catch (error) {
			console.error('Error deleting calendars:', error);
			// Optionally handle error - maybe show a notification to user
		}
	};

	updateMeeting = async (meeting, callback) => {
		// For testing - update locally
		const meetings = this.state.bookingPage.meetings.map((m) => {
			if (m._id === meeting._id) {
				return { ...m, ...meeting };
			}
			return m;
		});

		const updatedBookingPage = {
			...this.state.bookingPage,
			meetings: meetings
		};

		this.setState({ bookingPage: updatedBookingPage });
		setTimeout(() => {
			callback && callback();
		}, 500);

		// Keep the API call for future backend integration
		// const { orgId } = this.props;
		// const payload = {
		// 	request: 'updateBookingMeetings',
		// 	meetings: meetings
		// };
		// API().patch(`Organizations/${orgId}/booking/${this.state.bookingPage._id}`, payload).then((res) => {
		// 	if (res.data) {
		// 		const updatedBookingPage = {
		// 			...this.state.bookingPage,
		// 			meetings: res.data.meetings.map((m) => {
		// 				return {
		// 					...m,
		// 					status: m.confirmed ? 'Confirmed' : 'Pending',
		// 					link: `/${orgId}/booking/${this.state.bookingPage._id}/meetings/${m._id}`
		// 				};
		// 			})
		// 		};
		// 		this.setState({ bookingPage: updatedBookingPage });
		// 		callback && callback();
		// 	}
		// });
	};

	deleteMeetings = async (meetingIds, callback) => {
		// For testing - delete locally
		const filteredMeetings = this.state.bookingPage.meetings.filter((m) => !meetingIds.includes(m._id));
		const updatedBookingPage = {
			...this.state.bookingPage,
			meetings: filteredMeetings
		};

		this.setState({ bookingPage: updatedBookingPage });
		setTimeout(() => {
			callback && callback();
		}, 500);

		// Keep the API call for future backend integration
		// const { orgId } = this.props;
		// const payload = {
		// 	request: 'updateBookingMeetings',
		// 	meetings: filteredMeetings
		// };
		// API().patch(`Organizations/${orgId}/booking/${this.state.bookingPage._id}`, payload).then((res) => {
		// 	if (res.data) {
		// 		const updatedBookingPage = {
		// 			...this.state.bookingPage,
		// 			meetings: res.data.meetings.map((m) => {
		// 				return {
		// 					...m,
		// 					status: m.confirmed ? 'Confirmed' : 'Pending',
		// 					link: `/${orgId}/booking/${this.state.bookingPage._id}/meetings/${m._id}`
		// 				};
		// 			})
		// 		};
		// 		this.setState({ bookingPage: updatedBookingPage });
		// 		callback && callback();
		// 	}
		// });
	};

	approveRequestTimeSlot = (requestId, date, calendarId, timeSlot) => {
		// Implementation for approving a time slot
		const { orgId } = this.props;
		const payload = {
			request: 'approveRequestTimeSlot',
			bookingRequest: {
				_id: requestId,
				approvedTimes: {
					[date]: {
						[calendarId]: timeSlot
					}
				}
			}
		};
		API().patch(`Organizations/${orgId}/bookingPages/${this.state.bookingPage._id}`, payload).then((res) => {
			if (res.data) {
				// Find the request to get user info
				const request = this.state.bookingPage.requests.find(r => r._id === requestId);
				const user = request?.submission?.user || {
					firstName: request?.submission?.formData?.firstName || 'Unknown',
					lastName: request?.submission?.formData?.lastName || '',
					email: request?.submission?.formData?.email || ''
				};

				const updatedBookingPage = {
					...this.state.bookingPage,
					requests: this.state.bookingPage.requests.map((r) => {
						//push the approved time slot to the request
						if (r._id === requestId) {
							if (!r.approvedTimes) {
								r.approvedTimes = {};
							}
							if (!r.approvedTimes[date]) {
								r.approvedTimes[date] = {};
							}

							if (!r.approvedTimes[date][calendarId]) {
								r.approvedTimes[date][calendarId] = [];
							}
							r.approvedTimes[date][calendarId].push(timeSlot);
						}
						return r;
					}),
					calendars: this.state.bookingPage.calendars.map((calendar) => {
						if (calendar._id === calendarId) {
							// Add the booked spot to the calendar
							const newBookedSpot = {
								_id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`, // Generate unique ID
								date: date,
								time: timeSlot,
								request: requestId,
								spotsTaken: 1,
								status: 'approved',
								bookedAt: new Date().toISOString(),
								approvedBy: 'current-user-id', // This should be the actual user ID
								user: user
							};

							return {
								...calendar,
								bookedSpots: [...(calendar.bookedSpots || []), newBookedSpot]
							};
						}
						return calendar;
					})
				};
				this.setState({ bookingPage: updatedBookingPage });
			}
		});
	}

	denyRequestTimeSlot = (requestId, date, calendarId, timeSlot) => {
		// Implementation for denying a time slot
		const { orgId } = this.props;
		const payload = {
			request: 'denyRequestTimeSlot',
			bookingRequest: {
				_id: requestId,
				deniedTimes: {
					[date]: {
						[calendarId]: timeSlot
					}
				}
			}
		};
		API().patch(`Organizations/${orgId}/bookingPages/${this.state.bookingPage._id}`, payload).then((res) => {
			if (res.data) {
				const updatedBookingPage = {
					...this.state.bookingPage,
					requests: this.state.bookingPage.requests.map((r) => {
						//push the denied time slot to the request
						if (r._id === requestId) {
							if (!r.deniedTimes) {
								r.deniedTimes = {};
							}
							if (!r.deniedTimes[date]) {
								r.deniedTimes[date] = {};
							}

							if (!r.deniedTimes[date][calendarId]) {
								r.deniedTimes[date][calendarId] = [];
							}
							r.deniedTimes[date][calendarId].push(timeSlot);
						}
						return r;
					})
				};
				this.setState({ bookingPage: updatedBookingPage });
			}
		});
	}

	updateBookingPage = (updatedBookingPage) => {
		this.setState({ bookingPage: updatedBookingPage });
	};

	updateBookedTimeslot = (payload, callback) => {
		// Implementation for publishing the booking page
		const { orgId } = this.props;
		const payloadObj = {
			request: 'updateBookedTimeslot',
			...payload
		};


		API().patch(`Organizations/${orgId}/bookingPages/${this.state.bookingPage._id}`, payloadObj).then((res) => {
			if (res.data) {

				let updatedBookingPage = { ...res.data.bookingPage };

				// Update the specific calendar's bookedSpots
				updatedBookingPage.calendars = updatedBookingPage.calendars.map((calendar) => {
					let filteredBookedSpots = calendar.bookedSpots || [];
					filteredBookedSpots = filter(filteredBookedSpots, (spot) => spot.status !== 'canceled');

					return {
						...calendar,
						link: `/${orgId}/booking/${updatedBookingPage._id}/calendars/${calendar._id}`,
						bookingsCount: filteredBookedSpots ? filteredBookedSpots.length : 0,

					};

				});

				this.setState({ bookingPage: updatedBookingPage }, () => {
					callback && callback();
				});
			}
		});
	};




	publishBookingPage = () => {
		// Implementation for publishing the booking page
		const { orgId } = this.props;
		const payload = {
			request: 'publishBookingPage'
		};
		API().patch(`Organizations/${orgId}/bookingPages/${this.state.bookingPage._id}`, payload).then((res) => {
			if (res.data) {
				const updatedBookingPage = {
					...this.state.bookingPage,
					page: {
						...this.state.bookingPage.page,
						published: true
					}
				};
				this.setState({ bookingPage: updatedBookingPage });
			}
		});
	};

	unpublishBookingPage = () => {
		// Implementation for unpublishing the booking page
		const { orgId } = this.props;
		const payload = {
			request: 'unpublishBookingPage'
		};
		API().patch(`Organizations/${orgId}/bookingPages/${this.state.bookingPage._id}`, payload).then((res) => {
			if (res.data) {
				const updatedBookingPage = {
					...this.state.bookingPage,
					page: {
						...this.state.bookingPage.page,
						published: false
					}
				};
				this.setState({ bookingPage: updatedBookingPage });
			}
		});
	};

	render() {
		const {
			bookingPage,
			loading,
			sideMenuItems
		} = this.state;
		const { match: { params }, orgId } = this.props;
		const section = params.section;
		let sectionName = this.state.sectionName;

		if (section) {
			sideMenuItems.forEach((emi, index) => {
				if (emi.section === section) {
					sectionName = emi.name;
				}
			});
		}

		return (
			<div className="pageContainer">
				{!loading && (
					<div className="sectionContainer">
						<Switch>
							<Route path={`/:organization/booking/:bookingId/dashboard`}>
								<BookingDashboard
									bookingPage={bookingPage}
									sectionName={sectionName}
									orgId={orgId}
									organization={this.props.organization}
								/>
							</Route>

							<Route path={`/:organization/booking/:bookingId/form`}>
								<BookingFormBuilder
									bookingPage={bookingPage}
									sectionName={sectionName}
									orgId={orgId}
									calendars={bookingPage.calendars}
									organization={this.props.organization}
									saveBookingPageDetails={this.saveBookingPageDetails}
									eventMap={this.state.eventMap}
								/>
							</Route>

							<Route path={`/:organization/booking/:bookingId/emails`}>
								<BookingEmailTemplates
									bookingPage={bookingPage}
									sectionName={sectionName}
									orgId={orgId}
									organization={this.props.organization}
									updateBookingPage={this.updateBookingPage}
								/>
							</Route>

							<Route path={`/:organization/booking/:bookingId/calendars`}>
								<BookingCalendars
									bookingPage={bookingPage}
									sectionName={sectionName}
									orgId={orgId}
									calendars={bookingPage.calendars}
									addCalendar={this.addCalendar}
									saveCalendar={this.saveCalendar}
									deleteCalendars={this.deleteCalendars}
									approveRequestTimeSlot={this.approveRequestTimeSlot}
									denyRequestTimeSlot={this.denyRequestTimeSlot}
									cancelBooking={this.cancelBooking}
									updateBookedTimeslot={this.updateBookedTimeslot}
									eventVenue={this.state.eventVenue}
								/>
							</Route>

							<Route path={`/:organization/booking/:bookingId/publish`}>
								<BookingPublish
									bookingPage={bookingPage}
									sectionName={sectionName}
									orgId={orgId}
									organization={this.props.organization}
									publishBookingPage={this.publishBookingPage}
									unpublishBookingPage={this.unpublishBookingPage}
								/>
							</Route>

							<Route path={`/:organization/booking/:bookingId/registrants`}>
								<BookingRegistrants
									bookingPage={bookingPage}
									sectionName={sectionName}
									orgId={orgId}
									addRegistrant={this.addRegistrant}
									updateRegistrant={this.updateRegistrant}
									deleteRegistrants={this.deleteRegistrants}
								/>
							</Route>

							<Route path={`/:organization/booking/:bookingId/requests`}>
								<BookingMeetings
									bookingPage={bookingPage}
									sectionName={sectionName}
									orgId={orgId}
									requests={bookingPage.requests}
									approveRequestTimeSlot={this.approveRequestTimeSlot}
									denyRequestTimeSlot={this.denyRequestTimeSlot}
								/>
							</Route>
						</Switch>
					</div>
				)}
				<LoadingWizard text="Loading Booking Page" loading={loading} />
			</div>
		);
	}
}

export default withRouter(BookingPage);
